<template>
  <div>
    <header-admin-pages
      title="Форумы"
      :counter="getForums.length"
      :button="headerButton"/>

    <table>
      <tr>
        <td>Название форума</td>
        <td>Город</td>
        <td>Начало</td>
        <td>Конец</td>
<!--        <td>Основной форум</td>-->
        <td class="drop-icon"></td>
      </tr>
<!--      {{getForums}}-->
      <tr v-for="forum in reversed(getForums)" :key="`forum${forum.id}`">
        <td @click="clickItem(forum.id)">{{ forum.title }}</td>
        <td @click="clickItem(forum.id)">{{ forum.location }}</td>
        <td @click="clickItem(forum.id)">{{ forum.date_start }}</td>
        <td @click="clickItem(forum.id)">{{ forum.date_end }}</td>
<!--        <td @click="clickItem(forum.id)">{{ forum.global.forum }}</td>-->
        <td class="drop-icon">
          <drop-list @clickItem="clickItem"
                     :id-item="forum.id"
                     :edit-link="`/admin/forum_final/${forum.id}/edit`"/>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import HeaderAdminPages from '@/components/Admin/HeaderAdminPages'
import DropList from '@/components/Admin/DropList'

export default {
  name: 'forumFinal',

  components: {
    DropList,
    HeaderAdminPages
  },

  data () {
    return {
      headerButton: {
        title: 'Добавить форум',
        link: '/admin/forum_final/create'
      }
    }
  },

  mounted () {
    this.$store.dispatch('getForumsList')
  },

  methods: {
    clickItem (value) {
      console.log(value)
      if (value.value === 'del') {
        const consent = confirm('Вы уверены, чтобы хотите удалить форум?')
        if (consent) {
          this.$store.dispatch('deleteRegionalForum', value.id)
        } else {
          this.$noty.warning('Удаление отменено')
        }
      } else {
        this.$router.push({ path: `/admin/forum_final/${value}/edit` })
      }
    },
    async getRegionalForum () {
      this.$store.dispatch('getMainForumsList', 1)
      // const mainForumList = await [...this.$store.getters.GET_MAIN_FORUMS]
      // mainForumList.forEach(forum => {
      //   this.$store.dispatch('getMainForumsList', forum.id)
      // })
    },
    reversed (item) {
      return item !== null ? [...item].reverse() : ''
    }
  },

  computed: {
    getForums () {
      return this.$store.getters.GET_FORUMS
    }
  },
  watch: {
    // getForums () {
    //   this.getRegionalForum()
    // }
  }
}
</script>

<style scoped lang="scss">
  table{
    margin-top: 2rem;
    border-spacing: 0;
    border-collapse: collapse;

    tr{
      padding: 0;
      border-bottom: 1px solid #D5D6D9;

      td {
        width: 20%;
        font-size: .812rem;
        line-height: 154%;
        color: #1F3245;
        padding: 1.375rem 0 1.375rem 0;

        a {
          color: #246CB7;
        }

        img {
          cursor: pointer;
          width: 1.5rem;
          height: 1.5rem;
          object-fit: contain;
          object-position: center;
        }
      }

      &:first-of-type td{
        padding: 1rem 0;
        color: #5E686C;
      }
    }
  }
</style>
